module.exports = __webpack_public_path__ + "static/media/favicon.9ab93ade.io";